import { Route } from '@angular/router';

export const environmentImports: Route[] = [];
